export enum PermissionsEnum {
  // some modes but check as permission

  /** same that RA */
  RD = 'RA',
  /** same that RD */
  RA = 'RA',
  MBS = 'MBS',

  Provider = 'Provider',
  // end

  ADS = 'ADS',
  AccessToAllCompanies = 'AccessToAllCompanies',
  ActivateLicenseKey = 'ActivateLicenseKey',
  Administrator = 'Administrator',
  AllowBandwidthForCompanies = 'AllowBandwidthForCompanies',
  AssignTags = 'AssignTags',
  AuditLog = 'AuditLog',
  Backup = 'Backup',
  BackupHistory = 'BackupHistory',
  Billing = 'Billing',
  CapacityReport = 'CapacityReport',
  CloudRestore = 'CloudRestore',
  CustomizeDashboard = 'CustomizeDashboard',
  Dashboard = 'Dashboard',
  DeepInstinct = 'DeepInstinct',
  DirectConnectAccess = 'DirectConnectAccess',
  DocumentsManagement = 'DocumentsManagement',
  Downloads = 'Downloads',
  EC2Snapshots = 'EC2Snapshots',
  GoogleApps = 'GoogleApps',
  HelpMarketing = 'HelpMarketing',
  LicenseBuy = 'LicenseBuy',
  LicenseUsageHistory = 'LicenseUsageHistory',
  Licenses = 'Licenses',
  ManageCompanies = 'ManageCompanies',
  ManageImmutability = 'ManageImmutability',
  ManageRmmApiTokens = 'ManageRmmApiTokens',
  ManageTags = 'ManageTags',
  McpFullAccess = 'McpFullAccess',
  McpReadAccess = 'McpReadAccess',
  Monitoring = 'Monitoring',
  Notification = 'Notification',
  OnlineAccess = 'OnlineAccess',
  Package = 'Package',
  PSA = 'PSA',
  PurchaseHistory = 'PurchaseHistory',
  QuickRestore = 'QuickRestore',
  AgentlessRestore = 'AgentlessRestore',
  Rebranding = 'Rebranding',
  RemoteConnection = 'RemoteConnection',
  RemoteDeploy = 'RemoteDeploy',
  RemoteManagement = 'RemoteManagement',
  // Artificial permission — signals that an "RMM per administrator" license exists; not a real granular permission and not a manageable UI toggle.
  RmmPerAdminLicenseExists = 'RmmPerAdminLicenseExists',
  RmmCeEnabled = 'RmmCeEnabled',
  RmmPerEndpoint = 'RmmPerEndpoint',
  ShowDocuments = 'ShowDocuments',
  ShowTickets = 'ShowTickets',
  SecurityWidget = 'SecurityWidget',
  Storage = 'Storage',
  StorageUsage = 'StorageUsage',
  ShowAutotaskIntegration = 'ShowAutotaskIntegration',
  ShowBackupRestorePlansAndAgentSettings = 'ShowBackupRestorePlansAndAgentSettings',
  ShowDeepInstinct = 'ShowDeepInstinct',
  ShowDeepInstinctProvider = 'ShowDeepInstinctProvider',
  ShowRemoteConnection = 'ShowRemoteConnection',
  DeleteDataFromStorage = 'DeleteDataFromStorage',
  Rmm = 'RMM',
  UseOldConnectSettings = 'UseOldConnectSettings',
  Users = 'Users',
  UsersCreateEdit = 'UsersCreateEdit',
  UsersDelete = 'UsersDelete',
  AllowUBObjectLock = 'AllowUBObjectLock',
  ReserveAuthMethod = 'ReserveAuthMethod',
  RestoreFromIBBToAzure = 'RestoreFromIBBToAzure',
  RestoreFromIBBToEC2 = 'RestoreFromIBBToEC2',
  DisableNewStorageAccountsPage = 'DisableNewStorageAccountsPage',
  Chat = 'Chat',
  HideChat = 'HideChat',
  ManageStorageLimitsForUser = 'ManageStorageLimitsForUser',
  ManageStorageLimitsForCompany = 'ManageStorageLimitsForCompany',
  AddOrRemoveDestinationForUser = 'AddOrRemoveDestinationForUser',
  AddOrRemoveDestinationForCompany = 'AddOrRemoveDestinationForCompany',
  AllowTicketingSubsystem = 'AllowTicketingSubsystem',
  EnableSupportChat = 'EnableSupportChat',
  ShowMSP360ControlMobileApplication = 'ShowMSP360ControlMobileApplication',
  B2Only = 'B2Only',
  AutomaticLicenseRelease = 'AutomaticLicenseRelease',
  ManageSubscription = 'ManageSubscription'
}

// key - is allowed to show permission, values - are rules to show this permission
// [] - no rules, permission is always shown
// [A, B] - flat array = AND: shown only when every rule passes (can(A) && can(B))
// [[A], [B, C]] - nested array = OR of groups: shown when any group fully passes (can(A) || (can(B) && can(C)))
// missing key - permission is not shown
export const AdministratorPermissions: { readonly [key in PermissionsEnum]?: PermissionsEnum[] | PermissionsEnum[][] } = {
  [PermissionsEnum.ADS]: [],
  [PermissionsEnum.ActivateLicenseKey]: [],
  [PermissionsEnum.Administrator]: [],
  [PermissionsEnum.AgentlessRestore]: [],
  [PermissionsEnum.AssignTags]: [],
  [PermissionsEnum.AuditLog]: [],
  [PermissionsEnum.BackupHistory]: [],
  [PermissionsEnum.Billing]: [],
  [PermissionsEnum.CapacityReport]: [],
  [PermissionsEnum.CloudRestore]: [],
  [PermissionsEnum.CustomizeDashboard]: [],
  [PermissionsEnum.Dashboard]: [],
  [PermissionsEnum.DirectConnectAccess]: [],
  [PermissionsEnum.Downloads]: [],
  [PermissionsEnum.GoogleApps]: [],
  [PermissionsEnum.HelpMarketing]: [],
  [PermissionsEnum.LicenseBuy]: [],
  [PermissionsEnum.LicenseUsageHistory]: [],
  [PermissionsEnum.Licenses]: [],
  [PermissionsEnum.ManageCompanies]: [],
  [PermissionsEnum.ManageImmutability]: [],
  [PermissionsEnum.ManageTags]: [],
  [PermissionsEnum.Monitoring]: [],
  [PermissionsEnum.Notification]: [],
  [PermissionsEnum.OnlineAccess]: [],
  [PermissionsEnum.Package]: [],
  [PermissionsEnum.PSA]: [],
  [PermissionsEnum.PurchaseHistory]: [],
  [PermissionsEnum.QuickRestore]: [],
  [PermissionsEnum.Rebranding]: [],
  [PermissionsEnum.Rmm]: [[PermissionsEnum.RmmCeEnabled], [PermissionsEnum.RmmPerEndpoint]],
  [PermissionsEnum.ShowTickets]: [],
  [PermissionsEnum.RemoteDeploy]: [],
  [PermissionsEnum.DeleteDataFromStorage]: [],
  [PermissionsEnum.RemoteManagement]: [],
  [PermissionsEnum.Storage]: [],
  [PermissionsEnum.StorageUsage]: [],
  [PermissionsEnum.ShowBackupRestorePlansAndAgentSettings]: [],
  [PermissionsEnum.ShowDeepInstinct]: [PermissionsEnum.ShowDeepInstinctProvider],
  [PermissionsEnum.ShowRemoteConnection]: [],
  [PermissionsEnum.McpFullAccess]: [],
  [PermissionsEnum.McpReadAccess]: [],
  [PermissionsEnum.UseOldConnectSettings]: [],
  [PermissionsEnum.Users]: [],
  [PermissionsEnum.UsersCreateEdit]: [],
  [PermissionsEnum.UsersDelete]: [],
  [PermissionsEnum.ManageStorageLimitsForUser]: [],
  [PermissionsEnum.ManageStorageLimitsForCompany]: [],
  [PermissionsEnum.AddOrRemoveDestinationForUser]: [],
  [PermissionsEnum.AddOrRemoveDestinationForCompany]: [],
  [PermissionsEnum.EnableSupportChat]: [],
  [PermissionsEnum.ShowMSP360ControlMobileApplication]: []
};
